// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// 1. تعديل الاستيراد لنجلب الـ store الافتراضي والـ persistor
// (ملاحظة: إذا كان مسار الملف './store/store'، قم بتعديله بما يتناسب مع مشروعك)
import store, { persistor } from './store'; 

// 2. استيراد PersistGate
import { PersistGate } from 'redux-persist/integration/react'; 

import { ThemeContextProvider } from './style/ThemeContext'; // استيراد المزود المخصص
import { Toaster } from 'react-hot-toast'; // استيراد مكتبة الإشعارات

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* 3. تغليف التطبيق بـ PersistGate لمنع التحميل حتى يتم استرجاع البيانات المحفوظة */}
      <PersistGate loading={null} persistor={persistor}>
        {/* المزود المخصص الخاص بنا يدير الثيم و CssBaseline داخلياً */}
        <ThemeContextProvider>
          <BrowserRouter>
            <App />
            {/* تحضير Toast ليكون متاحاً في كل التطبيق */}
            <Toaster 
              position="top-center" 
              toastOptions={{
                // يمكنك تخصيص شكل الإشعارات هنا ليتناسب مع الثيم
                duration: 3000,
                style: {
                  borderRadius: '10px',
                  background: '#333',
                  color: '#fff',
                },
              }} 
            />
          </BrowserRouter>
        </ThemeContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);